<template>
    <div style="position: relative;left: 0;top: 0;bottom: 0;right: 0;width:100%;" v-loading.fullscreen.lock="fullscreenLoading">
        <div class="left-head">
            <el-row>
                <el-col :span="24">用户列表</el-col>
            </el-row>
        </div>
        <div class="left">
            <div class="left-top">
                <el-input v-model="filterText" size="small">
                    <template slot="prepend">用户名称/编号</template>
                </el-input>
            </div>
            <div class="left-middle">
                <el-radio-group v-model="meterType" size="mini" :disabled="unitLoading">
                    <el-radio-button label="2">电表</el-radio-button>
                    <el-radio-button label="1">水表</el-radio-button>
                </el-radio-group>
            </div>
            <div class="left-bottom">
                <el-tree
                    style="background-color: #fafafa"
                    class="filter-tree"
                    :data="energyUnit"
                    :props="defaultProps"
                    :default-expanded-keys="expandKeys"
                    :highlight-current="true"
                    node-key="id"
                    :filter-node-method="filterNode"
                    :expand-on-click-node="false"
                    ref="energyUnitRef"
                    v-loading="unitLoading"
                    :indent="fontSize"
                    @node-click="unitClick">
                </el-tree>
            </div>
        </div>
        <div class="right-head">
            <el-row>
                <el-col :span="24">充值统计</el-col>
            </el-row>
        </div>
        <div class="right">
            <div class="right-top">
                <div class="card-a">
                    <div class="card-left">
                        <div class="card-right-flex">
                            <svg-icon icon-class="累计充值成功"></svg-icon>
                        </div>
                    </div>
                    <div class="card-right">
                        <div class="card-right-flex">
                        <div class="card-right-top">
                            <span v-text="totalRechargeCount"></span>
                            <span class="card-right-top-unit">次</span>
                        </div>
                        <div class="card-right-bottom">
                            累计充值成功次数
                        </div>
                        </div>
                    </div>
                </div>
                <div class="card-b">
                    <div class="card-left">
                        <div class="card-right-flex">
                            <svg-icon icon-class="累计充值金额"></svg-icon>
                        </div>
                    </div>
                    <div class="card-right">
                        <div class="card-right-flex">
                        <div class="card-right-top">
                            <span v-text="totalRecharge"></span>
                            <span class="card-right-top-unit">元</span>
                        </div>
                        <div class="card-right-bottom">
                            累计充值金额
                        </div>
                        </div>
                    </div>
                </div>
                <div class="card-c">
                    <div class="card-left">
                        <div class="card-right-flex">
                            <svg-icon icon-class="累计充值金额"></svg-icon>
                        </div>
                    </div>
                    <div class="card-right">
                        <div class="card-right-flex">
                        <div class="card-right-top">
                            <span v-text="totalIncome"></span>
                            <span class="card-right-top-unit">元</span>
                        </div>
                        <div class="card-right-bottom">
                            累计财务收入
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right-bottom-head">
                <span style="font-size: 0.9375rem;font-weight: 600;line-height: 2.5rem;">充值记录明细</span>
                <span style="position: absolute;right: 30%;">
                    <el-radio-group v-model="timePeriod" size="mini" :disabled="tableLoading">
                            <el-radio-button label="day">日</el-radio-button>
                            <el-radio-button label="week">周</el-radio-button>
                            <el-radio-button label="month">月</el-radio-button>
                            <el-radio-button label="year">年</el-radio-button>
                        </el-radio-group>
                </span>
                <span style="position: absolute;right: 1%;">
                    <el-date-picker
                            :disabled="tableLoading"
                            size="small"
                            v-model="dateInterval"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                </span>
            </div>
            <div class="right-bottom" v-loading="tableLoading">
                <div style="width: 99.8%;height:calc(100% - 2rem);">
                    <flex>
                    <el-table
                            :data="tableData"
                            stripe
                            @filter-change="handleFilterChange"
                            height="100%"
                            size="mini"
                            style="width: 100%">
                        <el-table-column
                                label="序号"
                                width="60">
                            <template scope="scope"><span>{{scope.$index+(currentPage - 1) * pageSize + 1}} </span></template>
                        </el-table-column>
                        <el-table-column
                                prop="recharge_time"
                                label="充值时间"
                                :formatter="tableTimeFormat">
                        </el-table-column>
                        <el-table-column
                                prop="customer_user_name"
                                label="用户名称"
                                :formatter="tableStringFormat">
                        </el-table-column>
                        <el-table-column
                                prop="customer_user_code"
                                label="用户编号"
                                :formatter="tableStringFormat">
                        </el-table-column>
                        <el-table-column
                                prop="meter_name"
                                label="仪表名称"
                                :formatter="tableStringFormat">
                        </el-table-column>
                        <el-table-column
                                prop="meter_code"
                                label="仪表编号"
                                :formatter="tableStringFormat">
                        </el-table-column>
                        <el-table-column
                                prop="channel_name"
                                label="充值渠道"
                                column-key="channel"
                                :filters="channelFilter"
                                :formatter="tableStringFormat">
                        </el-table-column>
                        <el-table-column
                                prop="type_name"
                                label="付款方式"
                                column-key="type"
                                :filters="typeFilter"
                                :formatter="tableStringFormat">
                        </el-table-column>
                        <el-table-column
                                prop="recharge_amount"
                                label="充值金额（元）"
                                :formatter="tableNumberFormat">
                        </el-table-column>
                        <el-table-column
                                prop="pay_amount"
                                label="应付金额(元)"
                                :formatter="tableNumberFormat">
                        </el-table-column>
                        <el-table-column
                                prop="real_amount"
                                label="财务收入（元）"
                                :formatter="tableNumberFormat">
                        </el-table-column>
                        <el-table-column
                                prop="operate_name"
                                label="操作人"
                                :formatter="tableStringFormat">
                        </el-table-column>
                    </el-table>
                    </flex>
                </div>
                <div style="width: 100%;height:2rem;">
                    <div style="width: 80%;height:2rem;text-align: center;float: left;">
                        <el-pagination
                                background
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="currentPage"
                                :page-sizes="[20, 50, 100, 500, 1000]"
                                :page-size="pageSize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="pageTotal">
                        </el-pagination>
                    </div>
                    <div style="width: 20%;height:2rem;text-align: center;float:right;">
                        <el-button style="height:1.75rem;float:right;margin-top: 0.125rem;" size="mini" @click="exportClick">数据导出</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import { rechargeRecordByPage,selectRechargeType,selectRechargeChannel,totalRechargeCount,totalRecharge,totalRealAmount } from '@/api/rechargeRecord'
  import { tree, expandedCustomerWithMeter } from '@/utils/energyUtilTree'
  import { getStartAndEnd,format } from '@/utils/time'
  import { exportExcel } from '@/utils/excelUtil'
  import { comdify } from '@/utils/numberUtil'
  import Flex from '@/components/Flex'
  import {mapGetters} from 'vuex'
  export default {
    name: 'rechargeReport',
    components: {
      'flex': Flex
    },
    data() {
      return {
        filterText: '',
        energyUnit: [],
        meterType:"2",
        timePeriod:"month",
        dateInterval:[],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        unitLoading:false,
        tableData:[],
        currentPage:1,
        pageSize:100,
        pageTotal:0,
        meterIds:[],
        meterIdsTemp:[],
        channelFilter:[],
        typeFilter:[],
        channelFilterTemp:[],
        typeFilterTemp:[],
        totalRechargeCount:"0",
        totalRecharge:"0",
        totalIncome:"0",
        fullscreenLoading: false,
        tableLoading:false,
        expandKeys: []
    };
  },
    watch: {
      filterText(val) { //过滤能耗单元树
        this.$refs.energyUnitRef.filter(val);
      },
      meterType(val) { //监听能源类型变化
        this.filterText = ""
        this.selectEnergyUnit()
      },
      timePeriod(val) {  //监听时间区间变化
        if (val !== null) {
          //时间框置空
          this.dateInterval = null
          if (this.meterIds.length != 0) {
            this.currentPage=1
            this.tableByPage()
          }
        }
      },
      dateInterval(val) {    //监听时间框变化
        if (val !== null) {
          //时间区间置空
          this.timePeriod = null
          if (this.meterIds.length != 0) {
            this.currentPage=1
            this.tableByPage()
          }
        }
      },
      meterIds(val) {    //监听仪表id变化，查询数据
        this.currentPage = 1
        this.tableByPage()
      }
    },
    mounted() {
      this.selectEnergyUnit()
      this.selectRechargeBasicInfo()
    },
    computed: {
      ...mapGetters([
        'fontSize'
      ])
    },
    methods: {
      filterNode(value, data) { //过滤能耗单元树
        let flag=false;
        if (!value){
          flag=true;
        }else{
          if(data.type==1){ // 1 是用户
            if(data.label!==null&&data.label.indexOf(value) !== -1){
              flag=true;
            }else if(data.code!==null&&data.code.indexOf(value) !== -1){
              flag=true;
            }else{
              flag=false
            }
          }
          if(data.type==2){ // 2 是仪表
            if(data.father.name!==null&&data.father.name.indexOf(value) !== -1){
              flag=true;
            }else if(data.father.code!==null&&data.father.code.indexOf(value) !== -1){
              flag=true;
            }else{
              flag=false
            }
          }
        }
        return flag;
      },
      selectEnergyUnit() {  //查询能耗单元树
        this.unitLoading=true;
        const customerId = this.$store.getters.customerId
        tree(customerId,null,null,this.meterType,1).then(response => {
          this.energyUnit = response[0].children
          this.unitLoading = false
          // 设置默认展开
          for(let i in this.energyUnit){
            let energy = this.energyUnit[i]
            if(energy !== null && energy != undefined && energy.type !== 2){
              this.expandKeys.push(energy.id)
              for(let j in energy.children){
                let child = energy.children[j]
                if(child !== null && child != undefined && child.type !== 2){
                  this.expandKeys.push(child.id)
                }
              }
            }
          }
          // 选中第一个用户
          const keys = expandedCustomerWithMeter(this.energyUnit)
          if (keys != undefined) {
            this.$nextTick(() => {
              this.$refs.energyUnitRef.setCurrentKey(keys[0].customerId)
            })
            // 获取当前用户下所有仪表id
            this.meterIds=keys[1].meterId
          }
        }).catch(error => {
          this.unitLoading = false
          this.$message({
            type: 'warning',
            message: '无该能耗类型数据'
          })
        })
      },
      unitClick(data, node) { //点击能耗单元
        //获取点击节点下的所有仪表id
        this.meterIds=[]
        this.meterIdsTemp=[]
        this.getMeterIds(data)
        this.meterIds=this.meterIdsTemp
      },
      selectRechargeBasicInfo(){    //查询所有充值渠道、付款方式
        //查询付款方式
        selectRechargeType().then(response => {
          let result=response.infoJson
          for(let i in result){
            this.typeFilter.push({"text":result[i].rechargeType,"value":result[i].id})
          }
        }).catch(error => {
          this.$message({
            type: 'error',
            message: '付款方式查询失败'
          })
        })
        //查询充值渠道
        selectRechargeChannel().then(response => {
          let result=response.infoJson
          for(let i in result){
            this.channelFilter.push({"text":result[i].rechargeChannel,"value":result[i].id})
          }
        }).catch(error => {
          this.$message({
            type: 'error',
            message: '充值渠道查询失败'
          })
        })
      },
      handleSizeChange(val) {   //每页显示条数改变
        this.pageSize=val
        if(this.currentPage<=(parseInt((this.pageTotal-1)/this.pageSize)+1)){   //防止重复查询
          this.tableByPage()
        }
      },
      handleCurrentChange(val) {    //当前页数改变
        this.currentPage=val
        this.tableByPage()
      },
      getMeterIds(val){    //获取所有子节点的仪表id
        if(val.type==2){
          this.meterIdsTemp.push(val.typeId)
        }
        if(val.children!==undefined&&val.children!==null){
          for(let i in val.children){
            this.getMeterIds(val.children[i])
          }
        }
      },
      tableByPage(){    //数据表格分页查询，充值统计查询
        let startTime=null
        let endTime=null
        if(this.dateInterval!==null&&this.dateInterval.length!=0){  //时间框不为空使用时间框中的时间
          startTime=format(this.dateInterval[0],"YYYY-MM-DD HH:mm:ss")
          endTime=format(this.dateInterval[1],"YYYY-MM-DD HH:mm:ss")
        }else if(this.timePeriod!==null){  //时间区间不为空则使用时间区间的时间
          let timeJson=getStartAndEnd("now",this.timePeriod)
          startTime=format(timeJson.start,"YYYY-MM-DD HH:mm:ss")
          endTime=format(timeJson.end,"YYYY-MM-DD HH:mm:ss")
        }else{  //都为空则为异常
          this.$message({
            type: 'error',
            message: '请选择查询时间'
          })
          return
        }
        let offset=(this.currentPage-1) * this.pageSize
        //查询数据表格
        this.tableLoading=true
        this.unitLoading=true
        rechargeRecordByPage(this.meterIds,startTime,endTime,this.pageSize,offset,this.channelFilterTemp,this.typeFilterTemp,[2]).then(response => {
          this.tableLoading=false
          this.unitLoading=false
          this.tableData=response.infoJson.rows
          if(response.infoJson.total===undefined){
            this.pageTotal=0
          }else{
            this.pageTotal=response.infoJson.total
          }
        }).catch(error => {
          this.tableLoading=false
          this.unitLoading=false
          this.$message({
            type: 'error',
            message: '数据表格查询失败'
          })
        })
        //查询累计充值成功次数
        totalRechargeCount(this.meterIds,startTime,endTime,this.channelFilterTemp,this.typeFilterTemp,2).then(response => {
          if(response.infoJson==null){
            this.totalRechargeCount=0
          }else{
            this.totalRechargeCount=comdify(response.infoJson)
          }
        }).catch(error => {
          this.totalRechargeCount=0
          this.$message({
            type: 'error',
            message: '累计充值成功次数查询失败'
          })
        })
        //查询累计充值金额
        totalRecharge(this.meterIds,startTime,endTime,this.channelFilterTemp,this.typeFilterTemp,2).then(response => {
          if(response.infoJson==null){
            this.totalRecharge=0
          }else{
            this.totalRecharge=comdify(response.infoJson.toFixed(2))
          }
        }).catch(error => {
          this.totalRecharge=0
          this.$message({
            type: 'error',
            message: '累计充值金额查询失败'
          })
        })
        //查询累计财务收入
        totalRealAmount(this.meterIds,startTime,endTime,this.channelFilterTemp,this.typeFilterTemp,2).then(response => {
          if(response.infoJson==null){
            this.totalIncome=0
          }else{
            this.totalIncome=comdify(response.infoJson.toFixed(2))
          }
        }).catch(error => {
          this.totalIncome=0
          this.$message({
            type: 'error',
            message: '累计财务收入查询失败'
          })
        })
      },
      tableTimeFormat(row, column, cellValue){   //表格中时间格式化
        if(cellValue!==null&&cellValue!==undefined&&cellValue!==""){
          return format(cellValue,"YYYY-MM-DD HH:mm:ss")
        }
        return "--"
      },
      tableStringFormat(row, column, cellValue){   //表格中字符串格式化
        if(cellValue!==null&&cellValue!==undefined&&cellValue!==""){
          return cellValue
        }
        return "--"
      },
      tableNumberFormat(row, column, cellValue){   //表格中数字格式化
        if(cellValue!==null&&cellValue!==undefined&&cellValue!==""){
          return cellValue.toFixed(2)
        }
        return "--"
      },
      handleFilterChange(filters){  //表格筛选
        this.currentPage=1
        //充值渠道筛选
        if(filters.channel!==undefined){
            this.channelFilterTemp=filters.channel
        }
        //付款方式筛选
        if(filters.type!==undefined){
          this.typeFilterTemp=filters.type
        }
        //查询表格数据
        this.tableByPage()
      },
      exportClick(){    //点击数据导出
        let fileName="充值统计报表"
        let sheetName="充值统计报表"
        //查询待导出数据
        let startTime=null
        let endTime=null
        if(this.dateInterval!==null&&this.dateInterval.length!=0){  //时间框不为空使用时间框中的时间
          startTime=format(this.dateInterval[0],"YYYY-MM-DD HH:mm:ss")
          endTime=format(this.dateInterval[1],"YYYY-MM-DD HH:mm:ss")
        }else if(this.timePeriod!==null){  //时间区间不为空则使用时间区间的时间
          let timeJson=getStartAndEnd("now",this.timePeriod)
          startTime=format(timeJson.start,"YYYY-MM-DD HH:mm:ss")
          endTime=format(timeJson.end,"YYYY-MM-DD HH:mm:ss")
        }else{  //都为空则为异常
          this.$message({
            type: 'error',
            message: '请选择查询时间'
          })
          return
        }
        //查询数据表格
        this.fullscreenLoading=true
        rechargeRecordByPage(this.meterIds,startTime,endTime,1000000,0,this.channelFilterTemp,this.typeFilterTemp,[2]).then(response => {
          let dataTemp=response.infoJson.rows
          let data=[]
          //整理excel数据
          for(let i in dataTemp){
            let map={}
            if(dataTemp[i].recharge_time!==null&&dataTemp[i].recharge_time!==undefined&&dataTemp[i].recharge_time!==""){
              map["充值时间"]=format(dataTemp[i].recharge_time,"YYYY-MM-DD HH:mm:ss")
            }else{
              map["充值时间"]="--"
            }
            if(dataTemp[i].customer_user_name!==null&&dataTemp[i].customer_user_name!==undefined&&dataTemp[i].customer_user_name!==""){
              map["用户名称"]=dataTemp[i].customer_user_name
            }else{
              map["用户名称"]="--"
            }
            if(dataTemp[i].customer_user_code!==null&&dataTemp[i].customer_user_code!==undefined&&dataTemp[i].customer_user_code!==""){
              map["用户编号"]=dataTemp[i].customer_user_code
            }else{
              map["用户编号"]="--"
            }
            if(dataTemp[i].meter_name!==null&&dataTemp[i].meter_name!==undefined&&dataTemp[i].meter_name!==""){
              map["仪表名称"]=dataTemp[i].meter_name
            }else{
              map["仪表名称"]="--"
            }
            if(dataTemp[i].meter_code!==null&&dataTemp[i].meter_code!==undefined&&dataTemp[i].meter_code!==""){
              map["仪表编号"]=dataTemp[i].meter_code
            }else{
              map["仪表编号"]="--"
            }
            if(dataTemp[i].channel_name!==null&&dataTemp[i].channel_name!==undefined&&dataTemp[i].channel_name!==""){
              map["充值渠道"]=dataTemp[i].channel_name
            }else{
              map["充值渠道"]="--"
            }
            if(dataTemp[i].type_name!==null&&dataTemp[i].type_name!==undefined&&dataTemp[i].type_name!==""){
              map["付款方式"]=dataTemp[i].type_name
            }else{
              map["付款方式"]="--"
            }
            if(dataTemp[i].recharge_amount!==null&&dataTemp[i].recharge_amount!==undefined&&dataTemp[i].recharge_amount!==""){
              map["充值金额（元）"]=dataTemp[i].recharge_amount.toFixed(2)
            }else{
              map["充值金额（元）"]="--"
            }
            if(dataTemp[i].pay_amount!==null&&dataTemp[i].pay_amount!==undefined&&dataTemp[i].pay_amount!==""){
              map["应付金额（元）"]=dataTemp[i].pay_amount.toFixed(2)
            }else{
              map["应付金额（元）"]="--"
            }
            if(dataTemp[i].real_amount!==null&&dataTemp[i].real_amount!==undefined&&dataTemp[i].real_amount!==""){
              map["财务收入（元）"]=dataTemp[i].real_amount.toFixed(2)
            }else{
              map["财务收入（元）"]="--"
            }
            if(dataTemp[i].operate_name!==null&&dataTemp[i].operate_name!==undefined&&dataTemp[i].operate_name!==""){
              map["操作人"]=dataTemp[i].operate_name
            }else{
              map["操作人"]="--"
            }
            data.push(map)
          }
          //导出表格
          let result=exportExcel(data,fileName,sheetName)
          if(result==0){
            this.$message({
              type: 'error',
              message: '无待导出数据'
            })
          }else if(result==1){
            this.$message({
              type: 'error',
              message: '导出失败'
            })
          }
          this.fullscreenLoading=false
        }).catch(error => {
          this.fullscreenLoading=false
          this.$message({
            type: 'error',
            message: '获取导出数据失败'
          })
        })
      }
    }
  }
</script>

<style scoped>
    .el-col{
        line-height: 40px;
    }
    .el-col-24{
        font-size: 15px;
        font-weight: 600;
    }
    .left-head{
        position: absolute;
        left: 0;
        width:20%;
        padding-left: 10px;
    }
    .right-head {
        position: absolute;
        left: 19%;
        width: 77%;
        padding-left: 10px;
    }
    .left{
        position: absolute;
        left: 0;
        top: 40px;
        bottom: 10px;
        width:16%;
        height:calc(100% - 50px);
        background-color: #ffffff;
        border-radius: 4px;
    }
    .right{
        position: absolute;
        left: 19%;
        top: 40px;
        bottom: 10px;
        width:81%;
        height:calc(100% - 50px);
        border-radius: 4px;
    }
    .right-top{
        position: absolute;
        top:0;
        height: 17%;
        width: 100%;
    }
    .right-bottom-head{
        position: absolute;
        bottom: calc(75% + 5px);
        width:100%;
        padding-left: 10px;
    }
    .right-bottom{
        position: absolute;
        bottom: 0;
        height: calc(75% + 10px);
        width: 100%;
        background-color: #ffffff;
        overflow: auto;
        border-radius: 4px;
    }
    .card-a{
        position: absolute;
        height: 90%;
        width: 30%;
        border-radius: 8px;
        background: linear-gradient(#03C8D8, #0FD2F5);
        left: 0;
        right: 65%;
    }
    .card-b{
        position: absolute;
        height: 90%;
        width: 30%;
        border-radius: 8px;
        background: linear-gradient(#018AFE, #4BD2FF);
        left: 35%;
        right: 35%;
    }
    .card-c{
        position: absolute;
        height: 90%;
        width: 30%;
        border-radius: 8px;
        background: linear-gradient(#F87C2A, #F8C538);
        left: 70%;
        right: 0;
    }
    .card-left{
        position: absolute;
        left:0;
        height: 100%;
        width: 20%;
        background: rgba(255,255,255,0.2);
        border-radius: 8px;
        text-align: center;
    }
    .card-right{
        position: absolute;
        right:0;
        height: 100%;
        width: 80%;
        border-radius: 8px;
        text-align:center;
        color: #ffffff;
    }
    .left-top{
        width:90%;
        height:40px;
        padding:10px 5% 0 5%;
    }
    .left-middle{
        width:100%;
        height:40px;
        padding:5px 0;
        text-align: center;
        border-bottom: 1px #E5E6E6 solid;
    }
    .left-bottom{
        padding-top: 20px;
        padding-left: 20px;
        padding-right: 20px;
        height: calc(100% - 120px);
        overflow: auto;
    }
    .el-tree {
        min-width: 100%;
        display:inline-block;
    }
    .svg-icon{
        width: 50%;
        height: 50%;
    }
    .card-right-top{
        font-size: 25px;
        font-weight: 600;
    }
    .card-right-bottom{
        font-size: 12px;
        margin-top: 2px;
        color: #D9F4F8;
    }
    .card-right-top-unit{
        font-size: 12px;
        margin-left: 10px;
        color: #D9F4F8;
    }
    .card-right-flex{
        display: flex;
        flex-direction:column;
        height:100%;
        width: 100%;
        align-items:center;
        justify-content: center;
    }
</style>